/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { EpisodeOfCareSummary } from './EpisodeOfCareSummary';
import {
    EpisodeOfCareSummaryFromJSON,
    EpisodeOfCareSummaryFromJSONTyped,
    EpisodeOfCareSummaryToJSON,
    EpisodeOfCareSummaryToJSONTyped,
} from './EpisodeOfCareSummary';
import type { EncounterStatus } from './EncounterStatus';
import {
    EncounterStatusFromJSON,
    EncounterStatusFromJSONTyped,
    EncounterStatusToJSON,
    EncounterStatusToJSONTyped,
} from './EncounterStatus';

/**
 * 
 * @export
 * @interface EncounterWriteResult
 */
export interface EncounterWriteResult {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    episode_of_care_id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    status: EncounterStatus;
    /**
     * 
     */
    planned_start_at: Date;
    /**
     * 
     */
    planned_end_at: Date;
    /**
     * 
     */
    actual_start_at: Date;
    /**
     * 
     */
    actual_end_at: Date;
    /**
     * 
     */
    is_planned_start_confirmed: boolean;
    /**
     * 
     */
    is_planned_end_confirmed: boolean;
    /**
     * 
     */
    stay_type: EncounterWriteResultStayTypeEnum;
    /**
     * 
     */
    date_created: Date;
    /**
     * 
     */
    date_modified: Date;
    /**
     * 
     */
    episode_of_care: EpisodeOfCareSummary;
    /**
     * Send back as expected_latest_history_id on the next write
     */
    latest_history_id: string;
}


/**
 * @export
 */
export const EncounterWriteResultStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term',
} as const;
export type EncounterWriteResultStayTypeEnum = typeof EncounterWriteResultStayTypeEnum[keyof typeof EncounterWriteResultStayTypeEnum];


/**
 * Check if a given object implements the EncounterWriteResult interface.
 */
export function instanceOfEncounterWriteResult(value: object): value is EncounterWriteResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('episode_of_care_id' in value) || value['episode_of_care_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('planned_start_at' in value) || value['planned_start_at'] === undefined) return false;
    if (!('planned_end_at' in value) || value['planned_end_at'] === undefined) return false;
    if (!('actual_start_at' in value) || value['actual_start_at'] === undefined) return false;
    if (!('actual_end_at' in value) || value['actual_end_at'] === undefined) return false;
    if (!('is_planned_start_confirmed' in value) || value['is_planned_start_confirmed'] === undefined) return false;
    if (!('is_planned_end_confirmed' in value) || value['is_planned_end_confirmed'] === undefined) return false;
    if (!('stay_type' in value) || value['stay_type'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('date_modified' in value) || value['date_modified'] === undefined) return false;
    if (!('episode_of_care' in value) || value['episode_of_care'] === undefined) return false;
    if (!('latest_history_id' in value) || value['latest_history_id'] === undefined) return false;
    return true;
}

export function EncounterWriteResultFromJSON(json: any): EncounterWriteResult {
    return EncounterWriteResultFromJSONTyped(json, false);
}

export function EncounterWriteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): EncounterWriteResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'episode_of_care_id': json['episode_of_care_id'],
        'lead_id': json['lead_id'],
        'status': EncounterStatusFromJSON(json['status']),
        'planned_start_at': (json['planned_start_at'] == null ? json['planned_start_at'] : parseDateTime(json['planned_start_at'])),
        'planned_end_at': (json['planned_end_at'] == null ? json['planned_end_at'] : parseDateTime(json['planned_end_at'])),
        'actual_start_at': (json['actual_start_at'] == null ? json['actual_start_at'] : parseDateTime(json['actual_start_at'])),
        'actual_end_at': (json['actual_end_at'] == null ? json['actual_end_at'] : parseDateTime(json['actual_end_at'])),
        'is_planned_start_confirmed': json['is_planned_start_confirmed'],
        'is_planned_end_confirmed': json['is_planned_end_confirmed'],
        'stay_type': json['stay_type'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'date_modified': (json['date_modified'] == null ? json['date_modified'] : parseDateTime(json['date_modified'])),
        'episode_of_care': EpisodeOfCareSummaryFromJSON(json['episode_of_care']),
        'latest_history_id': json['latest_history_id'],
    };
}

export function EncounterWriteResultToJSON(json: any): EncounterWriteResult {
    return EncounterWriteResultToJSONTyped(json, false);
}

export function EncounterWriteResultToJSONTyped(value?: EncounterWriteResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'episode_of_care_id': value['episode_of_care_id'],
        'lead_id': value['lead_id'],
        'status': EncounterStatusToJSON(value['status']),
        'planned_start_at': value['planned_start_at'] == null ? value['planned_start_at'] : serializeDateTime(value['planned_start_at']),
        'planned_end_at': value['planned_end_at'] == null ? value['planned_end_at'] : serializeDateTime(value['planned_end_at']),
        'actual_start_at': value['actual_start_at'] == null ? value['actual_start_at'] : serializeDateTime(value['actual_start_at']),
        'actual_end_at': value['actual_end_at'] == null ? value['actual_end_at'] : serializeDateTime(value['actual_end_at']),
        'is_planned_start_confirmed': value['is_planned_start_confirmed'],
        'is_planned_end_confirmed': value['is_planned_end_confirmed'],
        'stay_type': value['stay_type'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_modified': value['date_modified'] == null ? value['date_modified'] : serializeDateTime(value['date_modified']),
        'episode_of_care': EpisodeOfCareSummaryToJSON(value['episode_of_care']),
        'latest_history_id': value['latest_history_id'],
    };
}

